import { Component, OnInit, isDevMode } from '@angular/core'
import { GlobService } from 'src/app/shared/glob.service'

@Component({
  selector: 'app-components',
  templateUrl: './components.component.html'
})
export class ComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // if (!isDevMode() && location.protocol === 'http:') window.location.href = location.href.replace('http', 'https');
  }
}
